(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["select_product"]) return;
  try {
    
          
        console.log("die");
        updateIcon();

         
        document.addEventListener("shopify:block:select",function(e){
          updateIcon();
        });
  
        document.addEventListener("shopify:section:select",function(e){
            
    		script = e.target.innerHTML.replace(/<script>(.*)<\/script>/, "$1"); // Remove tags
            console.log(script);
            eval(script); 
            document.getElementById('shopify-section-select_product').innerHtml = e.target.innerHTML;
            updateIcon();
        });
  
       
  
         document.addEventListener("shopify:section:load",function(e){
  
            updateIcon();
        });

  } catch(e) { console.error(e); }
})();

})();
